// extracted by mini-css-extract-plugin
export default {"root":"t0jbF","subcategoryIcon":"ni2Gv","label":"O2AiI","logoWrapper":"m9Zbf","logo":"r4vte"};